import Box from '@material-ui/core/Box';
import { makeStyles, createStyles } from '@material-ui/core/styles';
import React__default from 'react';

const styles = (theme) => createStyles({
  root: {
    display: "grid",
    gridTemplateColumns: "repeat(auto-fill, minmax(22em, 1fr))",
    gridAutoRows: "1fr",
    gridGap: theme.spacing(2)
  }
});
const useStyles = makeStyles(styles, { name: "BackstageItemCardGrid" });
function ItemCardGrid(props) {
  const { children, ...otherProps } = props;
  const classes = useStyles(otherProps);
  return /* @__PURE__ */ React__default.createElement(Box, { className: classes.root, ...otherProps }, children);
}

export { ItemCardGrid };
//# sourceMappingURL=ItemCardGrid.esm.js.map
